import { createStore } from 'zustand'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { AdyenPaymentStatusValues, PaymentLoadStatusValues, PaymentState, PaymentStore } from '../domain/types'

const defaultInitialState: PaymentState = {
  paymentOptions: null,
  selectedAmountType: '',
  selectedPaymentMethodType: null,
  customDepositAmount: null,
  loadStatus: PaymentLoadStatusValues.IDLE,
  status: AdyenPaymentStatusValues.IDLE,
  paymentResult: null,
  successUrl: null,
}

export const paymentStore = createPaymentStore()

export function createPaymentStore(initialState: PaymentState = defaultInitialState) {
  return createStore<PaymentStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },
    setIn: (path, value) => {
      set(state => setIn(state, path, value) as PaymentState)
    },
  }))
}
